import { FC, ReactNode } from 'react';
import { Typography, useTheme } from '@mui/material';

interface OwnProps {
  field?: string;
  label?: string;
  compact?: boolean;
  icon?: ReactNode;
  rest?: any;
}

const Section: FC<OwnProps> = ({ field, label, compact = false, icon, ...rest }) => {
  const theme = useTheme();
  return (
    <Typography
      component="div"
      sx={{
        borderBottom: `1px solid ${theme.palette.primary.main}`,
        fontSize: '1rem',
        fontWeight: 600,
        lineHeight: 1.3,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        ...(compact ? { mt: 0, mb: 1.5, pb: 0.375 } : { mt: 0, mb: 1.5, pb: 1 }),
      }}
      color="primary">
      {icon}
      {label}
    </Typography>
  );
};

export default Section;
